import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const CardWrapper = styled.div`
  margin-bottom: 12px;
  .description {
    font-size: ${Variables.font_sizes.x_medium};
    color: ${Variables.colors.green_800};
    margin-top: 8px;
    display: flex;
    align-items: center;
    i{
      display: flex;
      margin-left: 4px;
      &:before{
        color: ${Variables.colors.green_800};
        font-size: 8px;
      }
    }
  }
`;
export const CardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  background-color: ${Variables.colors.complementary};
  color: ${Variables.colors.complementary_800};
  width: 100%;
  min-height: 48px;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.16);
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: ${Variables.colors.primary_vivid};
    color: ${Variables.colors.complementary};
    span{
      color: ${Variables.colors.complementary};
    };
  }
  .right-text {
    display: flex;
    font-size: ${Variables.font_sizes.x2_medium};
  }
  .left-text {
    display: flex;
    flex-direction: row-reverse;
    font-size: ${Variables.font_sizes.large};
  }
  span {
    margin-right: 8px;
    margin-top: 0 !important;
    font-size: ${Variables.font_sizes.x_small};
    font-weight: ${Variables.font_weight.light};
  }
`;
